
import { useState, useEffect } from 'react';

export const useCounterAnimation = (targetValue, duration = 2000, isVisible = true) => {
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      if (typeof targetValue === 'number') {
        setCurrentValue(Math.floor(targetValue * easeOutQuart));
      } else {
        // For percentage values like "85%"
        const numericValue = parseInt(targetValue);
        setCurrentValue(Math.floor(numericValue * easeOutQuart));
      }
      
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [targetValue, duration, isVisible]);

  return currentValue;
};
